import { Label } from '@/components/atoms/texts/label';
import { Button } from '@/components/molecules/buttons/button';
import { FileText, CheckCircle, XCircle, Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Document({ documentType, uploaded, onDownload, onClick, loading , displayWarning}) {
    const { t } = useTranslation('global');
    const handleDownload = onDownload || onClick;

    return (
        <div
            className={[
                'flex items-center justify-between rounded-sm border px-firstDegree py-firstDegree',
                uploaded ? 'bg-white border-success' : displayWarning ? 'bg-warning20 border-warning' : 'bg-lighter border-none text-disabled ',
                loading ? 'opacity-60 pointer-events-none' : '',
            ].join(' ')}
        >
            <div className="flex items-center gap-secondDegree min-w-0">
                <span className={['inline-flex items-center justify-center', uploaded ? 'text-success-foreground' : displayWarning ? 'text-warning-foreground' : 'text-disabled'].join(' ')}>
                    <FileText className="h-4 w-4" />
                </span>

                <div className="min-w-0 leading-tight flex flex-col gap-firstDegree">
                    <Label className="truncate">{t(`management.onboarding.documentType.${documentType}`)}</Label>
                    <span className={['inline-flex items-center gap-1 text-sm', uploaded ? 'text-success-foreground' : displayWarning ? 'text-warning-foreground' : 'text-disabled'].join(' ')}>
                        {uploaded ? <CheckCircle className="h-3.5 w-3.5" /> : <XCircle className="h-3.5 w-3.5" />}
                        <Label size="small">{uploaded ? t('management.onboarding.documents.received') : t('management.onboarding.documents.missing')}</Label>
                    </span>
                </div>
            </div>

            {uploaded && (
                <Button
                    style="ghost"
                    onClick={handleDownload}
                    disabled={loading}
                    leftIcon={<Download  />}
                    showLeftIcon
                    showText={false}
                    aria-label={t('management.onboarding.documents.download')}
                >
                </Button>
            )}
        </div>
    );
}
